import { FormizoCustom, FormizoSchema } from "Components/LabIZO/Formizo/FormizoSchema.interface";

export const MaintenancePageSetting: FormizoSchema[] = [
  {
    header: "Header",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Header.TC",
    format: "textarea",
    variant: "outlined",
    rows: 2,
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Header.SC",
    format: "textarea",
    variant: "outlined",
    rows: 2,
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Header.EN",
    format: "textarea",
    variant: "outlined",
    rows: 2,
  },
  {
    header: "Content",
  },
  {
    label: "TC",
    name: "SettingDoc.Config.Content.TC",
    format: "textarea",
    variant: "outlined",
    rows: 3,
  },
  {
    label: "SC",
    name: "SettingDoc.Config.Content.SC",
    format: "textarea",
    variant: "outlined",
    rows: 3,
  },
  {
    label: "EN",
    name: "SettingDoc.Config.Content.EN",
    format: "textarea",
    variant: "outlined",
    rows: 3,
  },
];
